export { default as isEqual } from "lodash/isEqual";
